<template>
    <button v-show="showButton" @click="scrollToTop" class="scrollToTop">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#e91e63">            
            <path d="M7.41 16.59L12 12l4.59 4.59L18 15l-6-6-6 6z"/>        
        </svg>
    </button>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
 
export default {
    setup() {
        const showButton = ref(false);
 
        const checkScroll = () => {
            showButton.value = window.scrollY > 400;
        }
 
        const scrollToTop = () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
 
        onMounted(() => {
            window.addEventListener('scroll', checkScroll);
            // Vérifiez le scroll initial
            checkScroll();
        });
 
        onUnmounted(() => {
            window.removeEventListener('scroll', checkScroll);
        });
 
        return { showButton, scrollToTop };
    }
}
</script>

<style scoped>
.scrollToTop {
    position: fixed;
    bottom: 10em;
    right: 48px;
    padding: 0.3em;
    z-index: 4;
    width: 48px;
    height: 48px;
    border: solid 1px #e91e63; 
    border-radius: 24px;
    background-color: #ffffff;
    opacity: 0.7;
    transition: opacity 0.3s;
    cursor: pointer;
    justify-content: center;
    align-items: center;
}
.scrollToTop:hover {
    opacity: 1;
}
@media screen and (max-width: 750px ) {
    .scrollToTop {
        right: 15px;
        bottom: 2em;
    }

}
</style>